import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageNotFound from 'pages/PageNotFound';
import { UserPermission } from 'types/avp_permissions/permission';
import { useGetUserPermissionMutation, useGetUserPermissionQuery } from 'apis/AVPPermission/getPermissionAllAction';
import PageLoading from 'components/PageLoading';

type Props = {
  serviceName: string;
  children: React.ReactNode;
};

type PermissionContextType = {
  permissions: UserPermission | undefined;
  updateAssetClassPermission: (assetClass: string) => void;
  serviceName: string;
  
};

const PermissionContext = React.createContext<PermissionContextType>({
  permissions: undefined,
  updateAssetClassPermission: () => {},
  serviceName: '',
});

const PermissionProvider = ({ serviceName, children }: Props) => {
  const { project_id, asset_template_id } = useParams();
  const [permissions, setPermissions] = React.useState<UserPermission | undefined>(undefined);



  const { data, isLoading, isError } = useGetUserPermissionQuery({
    projectId: project_id!,
    serviceName,
    assetTemplateId: asset_template_id,
  });
  const { mutate: getUserPermission } = useGetUserPermissionMutation();

  useEffect(() => {
    if (data) {
      setPermissions(data);
    }
  }, [data]);

  // Function to update permissions based on asset class
  const updateAssetClassPermission = (assetClass: string) => {
    const reqParams = { projectId: project_id!, serviceName, assetClass };
    getUserPermission(reqParams, {
      onSuccess: (newPermissions) => {
        setPermissions(newPermissions);
      },
    });
  };


  if (isLoading) return <PageLoading />;
  if (isError || !project_id) return <PageNotFound />;

  return (
    <PermissionContext.Provider value={{ permissions, updateAssetClassPermission, serviceName }}>
      {children}
    </PermissionContext.Provider>
  );
};

export { PermissionProvider };
export default PermissionContext;
